import styled from "@emotion/styled";

export const ReplacementReviewButtonsWrapper = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-end",
	gap: "10px",
	marginTop: "16px",
	"button:first-of-type": {
		width: "20px"
	},
	"button:last-of-type": {
		width: "350px"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column-reverse",
		"button:last-of-type, button:first-of-type": {
			width: "100%"
		}
	}
}));
